import { useGetFeaturesFlags } from "@/hooks/useGetFeaturesFlags/useGetFeaturesFlags";
import { FeaturesFlagsType } from "@/hooks/useGetFeaturesFlags/useGetFeaturesFlags.decl";
import { Loading } from "@dashboard/library";
import { PropsWithChildren, createContext, useContext } from "react";

// Create the context with a default value
const FeatureFlagsContext = createContext<FeaturesFlagsType | undefined>(
  undefined
);

export function FeatureFlagsProvider({ children }: PropsWithChildren) {
  const { loading, ...featureFlags } = useGetFeaturesFlags();

  // Show loading state while feature flags are being fetched
  if (loading) {
    return <Loading data-test="feature-flags-loading" />;
  }

  return (
    <FeatureFlagsContext.Provider value={featureFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
}

// Custom hook to use feature flags
export function useFeatureFlags() {
  const context = useContext(FeatureFlagsContext);

  if (context === undefined) {
    throw new Error(
      "useFeatureFlags must be used within a FeatureFlagsProvider"
    );
  }

  return context;
}
